import i18n from '../../locales/index'
/* eslint-disable */
import { genBasicStore } from '../vuex';
import assign from 'lodash/assign';
import axios from 'axios';
import { Message } from 'view-design'

const store = genBasicStore('seat');

assign(store.actions, {
  async bindSticker ({ commit }, params) {
    const others = {
      fresh_sticker_code: params.code
    }
    await axios.post(`seats/${params.id}/bind`, others) 
    Message.success(i18n.t('pages_combo_index_287'))
  }
})

export default store;